import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { useClipboard } from '../context/ClipboardContext';

import {
    Box, Typography, Button, Card, CardContent, Grid, TextField,
    Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress,
    Chip, Alert, Divider, IconButton, Snackbar, InputAdornment,
    Fab, Badge, Tooltip, Menu, MenuItem, ListItemText, ListItemIcon,
    Accordion, AccordionSummary, AccordionDetails, List, ListItem, ListItemButton,
    ListItemSecondaryAction
} from '@mui/material';

import {
    Add as AddIcon,
    Search as SearchIcon,
    LocalPharmacy as PharmacyIcon,
    AddShoppingCart as AddShoppingCartIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
    Visibility as VisibilityIcon,
    ShoppingCart as ShoppingCartIcon,
    Close as CloseIcon,
    Warning as WarningIcon,
    Science as ScienceIcon,
    Business as BusinessIcon,
    FlashOn as FlashIcon,
    Save as SaveIcon,
    Star as StarIcon,
    StarBorder as StarBorderIcon,
    ExpandMore as ExpandMoreIcon,
    Category as CategoryIcon,
    FilterList as FilterIcon,
    DeleteSweep as DeleteSweepIcon,
    ReceiptLong as ReceiptIcon
} from '@mui/icons-material';

const API_URL = process.env.REACT_APP_API_URL || 'https://luiatro-health-cloud-production.up.railway.app';

// --- DATOS ATC MAESTROS ---
const ATC_MAPPING = {
    "A": "Tracto alimentario y metabolismo",
    "A01": "Preparados estomatologicos",
    "A02": "Agentes para el tratamiento de alteraciones causadas por acidos",
    "A03": "Agentes contra padecimientos funcionales del estomago e intestino",
    "A04": "Antiemeticos y antinauseosos",
    "A05": "Terapia biliar y hepatica",
    "A06": "Agentes contra el estrenimiento",
    "A07": "Antidiarreicos, antiinfecciosos y antiinflamatorios intestinales",
    "A08": "Preparados antiobesidad, excl. productos dieteticos",
    "A09": "Digestivos, incl. enzimas",
    "A10": "Antidiabeticos",
    "A11": "Vitaminas",
    "A12": "Suplementos minerales",
    "A13": "Tonicos",
    "A14": "Agentes anabolicos para uso sistemico",
    "A15": "Estimulantes del apetito",
    "A16": "Otros productos para el tracto alimentario y metabolismo",
    "B": "Sangre y organos hematopoyeticos",
    "B01": "Agentes antitromboticos",
    "B02": "Antihemorragicos",
    "B03": "Preparados antianemicos",
    "B05": "Sustitutos de sangre y soluciones para perfusion",
    "B06": "Otros agentes hematologicos",
    "C": "Sistema cardiovascular",
    "C01": "Terapia cardiaca",
    "C02": "Antihipertensivos",
    "C03": "Diureticos",
    "C04": "Vasodilatadores perifericos",
    "C05": "Vasoprotectores",
    "C07": "Betabloqueantes",
    "C08": "Bloqueantes del canal de calcio",
    "C09": "Agentes activos sobre el sistema renina-angiotensina",
    "C10": "Agentes modificadores de los lipidos",
    "D": "Dermatologicos",
    "D01": "Antifungicos para uso dermatologico",
    "D02": "Emolientes y protectores",
    "D03": "Preparados para el tratamiento de heridas y ulceras",
    "D04": "Antipruriginosos incl. antihistaminicos, anestesicos, etc.",
    "D05": "Antipsoriasicos",
    "D06": "Antibioticos y quimioterapicos para uso dermatologico",
    "D07": "Preparados dermatologicos con corticosteroides",
    "D08": "Antisepticos y desinfectantes",
    "D09": "Apositos medicamentosos",
    "D10": "Preparados contra el acne",
    "D11": "Otros preparados dermatologicos",
    "G": "Sistema genitourinario y hormonas sexuales",
    "G01": "Antiinfecciosos y antisepticos ginecologicos",
    "G02": "Otros preparados ginecologicos",
    "G03": "Hormonas sexuales y moduladores del sistema genital",
    "G04": "Urologicos",
    "H": "Preparados hormonales sistemicos, excluyendo hormonas sexuales e insulinas",
    "H01": "Hormonas hipofisiarias, hipotalamicas y analogos",
    "H02": "Corticosteroides para uso sistemico",
    "H03": "Terapia tiroidea",
    "H04": "Hormonas pancreaticas",
    "H05": "Homeostasis del calcio",
    "J": "Antiinfecciosos para uso sistemico",
    "J01": "Antibacterianos para uso sistemico",
    "J02": "Antimicoticos de uso sistemico",
    "J04": "Antimicobacterias",
    "J05": "Antivirales de uso sistemico",
    "J06": "Sueros inmunes e inmunoglobulinas",
    "J07": "Vacunas",
    "L": "Antineoplasicos e inmunomoduladores",
    "L01": "Antineoplasicos",
    "L02": "Terapia endocrina",
    "L03": "Inmunoestimulantes",
    "L04": "Inmunosupresores",
    "M": "Sistema musculoesqueletico",
    "M01": "Antiinflamatorios y antirreumaticos",
    "M02": "Productos topicos para dolor articular y muscular",
    "M03": "Relajantes musculares",
    "M04": "Antigotosos",
    "M05": "Preparados para el tratamiento de enfermedades oseas",
    "M09": "Otros medicamentos para desordenes del sistema musculoesqueletico",
    "N": "Sistema nervioso",
    "N01": "Anestesicos",
    "N02": "Analgesicos",
    "N03": "Antiepilepticos",
    "N04": "Antiparkinsonianos",
    "N05": "Psicolepticos",
    "N06": "Psicoanalepticos",
    "N07": "Otros farmacos activos sobre el sistema nervioso",
    "P": "Antiparasitarios, insecticidas y repelentes",
    "P01": "Antiprotozoarios",
    "P02": "Antihelminticos",
    "P03": "Ectoparasiticidas, incl. escabicidas, insecticidas y repelentes",
    "R": "Sistema respiratorio",
    "R01": "Preparaciones nasales",
    "R02": "Preparados para la garganta",
    "R03": "Agentes contra padecimientos obstructivos de las vias respiratorias",
    "R05": "Preparados para la tos y el resfriado",
    "R06": "Antihistaminicos para uso sistemico",
    "R07": "Otros productos para el sistema respiratorio",
    "S": "Organos de los sentidos",
    "S01": "Oftalmologicos",
    "S02": "Otologicos",
    "S03": "Preparados oftalmologicos y otologicos",
    "V": "Varios",
    "V01": "Alergenos",
    "V03": "Todos los demas preparados terapeuticos",
    "V04": "Agentes diagnosticos",
    "V06": "Nutrientes generales",
    "V07": "Todos los demas productos no terapeuticos",
    "V08": "Medios de contraste",
    "V09": "Radiofarmacos para diagnostico",
    "V10": "Radiofarmacos terapeuticos",
    "W": "Cosmeticos",
    "W01": "Cremas, emulsiones, lociones, geles y aceites para la piel",
    "W03": "Maquillaje (liquidos, pastas, polvos)",
    "W07": "Productos para bano y ducha (sales, espumas, aceites, geles)",
    "W09": "Desodorantes y antitranspirantes",
    "W10": "Productos capilares",
    "W13": "Productos para labios",
    "W14": "Productos para cuidado bucal y dental",
    "W15": "Productos para cuidado y maquillaje de unas",
    "W16": "Productos para el cuidado intimo externo",
    "W17": "Productos solares",
    "W20": "Productos antiarrugas",
    "W21": "Productos infantiles",
    "X": "Alimentos y dieteticos",
    "X01": "Alimentos personas sanas",
    "X02": "Alimentos para regimenes nutricionales especificos",
    "X03": "Alimentos especificos para regimenes dieteticos"
};

// --- UTILIDAD: CONSTRUIR ÁRBOL DE CATEGORÍAS ---
const getAtcTree = () => {
    const tree = [];
    Object.keys(ATC_MAPPING).forEach(code => {
        if (code.length === 1) {
            tree.push({ code, label: ATC_MAPPING[code], children: [] });
        }
    });
    Object.keys(ATC_MAPPING).forEach(code => {
        if (code.length > 1) {
            const parentCode = code.charAt(0);
            const parent = tree.find(node => node.code === parentCode);
            if (parent) {
                parent.children.push({ code, label: ATC_MAPPING[code] });
            }
        }
    });
    tree.push({ 
        code: 'SIN_CLASIFICAR', 
        label: 'Medicamentos sin Clasificar', 
        children: [{ code: 'SC', label: 'Sin Clasificar / Pendientes' }] 
    });
    return tree;
};

// Hook de Debounce
const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const handler = setTimeout(() => setDebouncedValue(value), delay);
        return () => clearTimeout(handler);
    }, [value, delay]);
    return debouncedValue;
};

// --- COMPONENTE: CAMPO CON MACROS ---
const MacroTextField = ({ label, value, onChange, type, user }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [macros, setMacros] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showSaveInput, setShowSaveInput] = useState(false);
    const [newMacroName, setNewMacroName] = useState('');

    const fetchMacros = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${API_URL}/api/vademecum-macros?type=${type}`, {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            });
            if (res.ok) setMacros(await res.json());
        } catch(e) { console.error(e); }
        setLoading(false);
    };

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
        fetchMacros();
        setShowSaveInput(false);
    };

    const handleSelect = (content) => {
        const newValue = value ? `${value}\n${content}` : content;
        onChange({ target: { value: newValue } });
        setAnchorEl(null);
    };

    const handleSaveNewMacro = async () => {
        if(!newMacroName || !value) return;
        try {
            await fetch(`${API_URL}/api/vademecum-macros`, {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}` 
                },
                body: JSON.stringify({ name: newMacroName, content: value, type })
            });
            setAnchorEl(null);
            setNewMacroName('');
        } catch(e) { alert("Error guardando macro"); }
    };

    return (
        <Box sx={{ position: 'relative' }}>
            <TextField
                label={label}
                fullWidth
                multiline
                rows={3}
                value={value}
                onChange={onChange}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end" sx={{ alignSelf: 'flex-start', mt: 1 }}>
                            <Tooltip title="Usar/Guardar Macro">
                                <IconButton onClick={handleOpen} color="warning" size="small">
                                    <FlashIcon />
                                </IconButton>
                            </Tooltip>
                        </InputAdornment>
                    )
                }}
                color={type === 'contraindications' ? 'error' : 'primary'}
            />
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                PaperProps={{ style: { maxHeight: 300, width: 300 } }}
            >
                <MenuItem disableRipple sx={{ bgcolor: '#f5f5f5', borderBottom: '1px solid #eee', flexDirection: 'column', alignItems: 'stretch', p:1 }}>
                    {!showSaveInput ? (
                        <Button startIcon={<SaveIcon />} size="small" fullWidth onClick={() => setShowSaveInput(true)} disabled={!value}>
                            Guardar texto actual como Macro
                        </Button>
                    ) : (
                        <Box sx={{ display:'flex', gap:1 }}>
                            <TextField size="small" placeholder="Nombre..." value={newMacroName} onChange={e=>setNewMacroName(e.target.value)} autoFocus />
                            <Button variant="contained" size="small" onClick={handleSaveNewMacro}>OK</Button>
                        </Box>
                    )}
                </MenuItem>
                {loading ? <MenuItem disabled>Cargando...</MenuItem> : (
                    macros.length === 0 ? (
                        <MenuItem disabled><Typography variant="caption">No hay macros guardados</Typography></MenuItem>
                    ) : (
                        macros.map(m => (
                            <MenuItem key={m.id} onClick={() => handleSelect(m.content)} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <ListItemText primary={m.name} secondary={m.content.substring(0, 30) + '...'} />
                            </MenuItem>
                        ))
                    )
                )}
            </Menu>
        </Box>
    );
};

const AtcCategoryDialog = ({ open, onClose, onSelect }) => {
    const atcTree = useMemo(() => getAtcTree(), []);
    const [selectedParent, setSelectedParent] = useState(null);
    const handleBack = () => setSelectedParent(null);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle sx={{ bgcolor: '#1976d2', color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
                {selectedParent ? (<IconButton onClick={handleBack} sx={{ color: 'white', mr: 1 }}><ExpandMoreIcon sx={{ transform: 'rotate(90deg)' }} /></IconButton>) : <CategoryIcon />}
                {selectedParent ? `${selectedParent.code} - ${selectedParent.label}` : 'Seleccione una Categoría Principal'}
            </DialogTitle>
            <DialogContent dividers>
                <List>
                    {!selectedParent ? (
                        atcTree.map((node) => (
                            <ListItemButton key={node.code} onClick={() => setSelectedParent(node)}>
                                <ListItemIcon>
                                    <Box sx={{ width: 32, height: 32, borderRadius: '50%', bgcolor: '#e3f2fd', color: '#1976d2', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>{node.code.substring(0,2)}</Box>
                                </ListItemIcon>
                                <ListItemText primary={node.label} primaryTypographyProps={{ fontWeight: 500 }} />
                                <ExpandMoreIcon color="action" sx={{ transform: 'rotate(-90deg)' }} />
                            </ListItemButton>
                        ))
                    ) : (
                        selectedParent.children.length > 0 ? (
                            selectedParent.children.map((child) => (
                                <ListItemButton key={child.code} onClick={() => onSelect(child)}>
                                    <ListItemIcon><ScienceIcon color="action" /></ListItemIcon>
                                    <ListItemText primary={`${child.code} - ${child.label}`} secondary="Haga clic para seleccionar" />
                                </ListItemButton>
                            ))
                        ) : (
                            <ListItem><ListItemText primary="No hay subcategorías disponibles" /></ListItem>
                        )
                    )}
                </List>
            </DialogContent>
            <DialogActions><Button onClick={onClose}>Cerrar</Button></DialogActions>
        </Dialog>
    );
};

// =============================================================================
//  PÁGINA PRINCIPAL VADEMECUM (V3.3 FINAL - CARRITO ROBUSTO CON IDs)
// =============================================================================
const VademecumPage = () => {
    const { user } = useAuth();
    // ⚠️ ATENCIÓN: El Context ya debe tener 'removeFromClipboard' con ID
    const { addToClipboard, clipboardItems, removeFromClipboard, clearClipboard } = useClipboard();

    const [medications, setMedications] = useState([]);
    const [search, setSearch] = useState('');
    const debouncedSearch = useDebounce(search, 500); 

    const [loading, setLoading] = useState(false);
    const [notification, setNotification] = useState('');
    const [activeAtcFilter, setActiveAtcFilter] = useState(null); 

    // --- FAVORITOS (EN LA NUBE) ---
    const [favorites, setFavorites] = useState([]);
    const [showFavorites, setShowFavorites] = useState(false); 
    const [loadingFavs, setLoadingFavs] = useState(false);

    // --- ESTADO CARRITO ---
    const [openCart, setOpenCart] = useState(false);

    // 1. CARGAR FAVORITOS
    const fetchFavorites = useCallback(async () => {
        if (!user) return;
        setLoadingFavs(true);
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${API_URL}/api/vademecum-favorites`, { 
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                setFavorites(data);
            }
        } catch (e) { console.error("Error cargando favoritos", e); }
        setLoadingFavs(false);
    }, [user]);

    useEffect(() => {
        fetchFavorites();
    }, [fetchFavorites]);

    // 🌟 COMPUTADO: FAVORITOS ORDENADOS ALFABÉTICAMENTE
    const sortedFavorites = useMemo(() => {
        return [...favorites].sort((a, b) => a.name.localeCompare(b.name));
    }, [favorites]);

    const toggleFavorite = async (med) => {
        const token = localStorage.getItem('token');
        const isFav = favorites.some(f => f.id === med.id); 
        try {
            if (isFav) {
                const res = await fetch(`${API_URL}/api/vademecum-favorites/${med.id}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if(res.ok) {
                    setFavorites(prev => prev.filter(f => f.id !== med.id));
                    setNotification('Removido de favoritos');
                }
            } else {
                const res = await fetch(`${API_URL}/api/vademecum-favorites`, {
                    method: 'POST',
                    headers: { 
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}` 
                    },
                    body: JSON.stringify({ medicationId: med.id })
                });
                if(res.ok) {
                    setFavorites(prev => [...prev, med]); 
                    setNotification('⭐ Añadido a favoritos');
                    fetchFavorites(); 
                }
            }
        } catch (e) {
            setNotification('❌ Error sincronizando favoritos');
        }
    };

    // --- MODALES ---
    const [openForm, setOpenForm] = useState(false); 
    const [openDetail, setOpenDetail] = useState(false);
    const [openContra, setOpenContra] = useState(false);
    const [openAtcSelector, setOpenAtcSelector] = useState(false);
    const [atcSelectorMode, setAtcSelectorMode] = useState('filter'); 

    const [currentMed, setCurrentMed] = useState({
        id: null, name: '', activeIngredient: '', laboratory: '',
        atcCode: '', therapeuticClass: '', concentration: '',
        pharmaceuticalForm: '', administrationVia: '',
        indications: '', posology: '', contraindications: ''
    });

    const fetchMeds = useCallback(async (query, atcFilter = null) => {
        setLoading(true);
        setMedications([]); 
        try {
            const token = localStorage.getItem('token');
            if (!token) { setLoading(false); return; }
            let url = `${API_URL}/api/vademecum`;
            const params = [];
            if (query) params.push(`q=${encodeURIComponent(query)}`);
            if (atcFilter && atcFilter.code !== 'SC') params.push(`atc=${atcFilter.code}`);
            if (params.length > 0) url += `?${params.join('&')}`;
            const res = await fetch(url, { headers: { 'Authorization': `Bearer ${token}` } });
            if (res.ok) {
                let data = await res.json();
                if (atcFilter?.code === 'SC') {
                    data = data.filter(m => !m.atcCode || m.atcCode === 'Sin Clasificar' || m.atcCode === 'SC');
                }
                setMedications(data);
            }
        } catch (e) { console.error(e); }
        setLoading(false);
    }, []);

    useEffect(() => {
        fetchMeds(debouncedSearch, activeAtcFilter);
    }, [debouncedSearch, activeAtcFilter, fetchMeds]);

    const handleAtcSelect = (category) => {
        setOpenAtcSelector(false);
        if (atcSelectorMode === 'filter') {
            setActiveAtcFilter(category);
            setSearch(''); 
        } else {
            setCurrentMed(prev => ({
                ...prev,
                atcCode: category.code === 'SC' ? 'Sin Clasificar' : category.code,
                therapeuticClass: category.label
            }));
        }
    };

    const handleSave = async () => {
        if (!currentMed.name) return setNotification("⚠️ Nombre obligatorio");
        const token = localStorage.getItem('token');
        const isEditing = !!currentMed.id;
        const url = isEditing ? `${API_URL}/api/vademecum/${currentMed.id}` : `${API_URL}/api/vademecum`;
        const method = isEditing ? 'PUT' : 'POST';
        try {
            const res = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify(currentMed)
            });
            if (res.ok) {
                setNotification(isEditing ? "✅ Actualizado" : "✅ Creado");
                setOpenForm(false);
                fetchMeds(debouncedSearch, activeAtcFilter);
            } else { setNotification("❌ Error al guardar"); }
        } catch (e) { setNotification("❌ Error de red"); }
    };

    const handleDelete = async (med) => {
        if (!window.confirm("¿Eliminar este medicamento?")) return;
        const token = localStorage.getItem('token');
        try {
            const res = await fetch(`${API_URL}/api/vademecum/${med.id}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                setNotification("🗑️ Eliminado");
                fetchMeds(debouncedSearch, activeAtcFilter);
            }
        } catch (e) { setNotification("❌ Error de red"); }
    };

    const handleAddCart = (med) => {
    addToClipboard({
        commercialName: med.name,
        activeIngredient: med.activeIngredient,
        concentration: med.concentration || '', // Asegurar que viaje la concentración
        form: med.pharmaceuticalForm || '',      // Asegurar que viaje la forma
        presentation: med.presentation || '',    // Asegurar que viaje la presentación
        dosage: med.posology || 'Según criterio médico',
    });
    setNotification(`🛒 "${med.name}" añadido al récipe`);
};

    // --- ACCIÓN DE BORRAR DEL CARRITO (POR ID) ---
    const handleRemoveFromCart = (itemCartId) => {
        if (removeFromClipboard) {
            removeFromClipboard(itemCartId); // Ahora pasamos el ID único
        } else {
            alert("⚠️ Error de contexto.");
        }
    };

    const canEdit = (med) => {
        if (user.role === 'administrador') return true;
        if (med.createdBy === user.id) return true;
        return false;
    };

    const renderMedCard = (med) => {
        const isFav = favorites.some(f => f.id === med.id);
        return (
            <Card elevation={3} sx={{ height: '100%', display: 'flex', flexDirection: 'column', position: 'relative', transition: '0.3s', '&:hover': { transform: 'translateY(-3px)', boxShadow: 6 } }}>
                <CardContent sx={{ flexGrow: 1, p: 2 }}>
                    <IconButton onClick={(e) => { e.stopPropagation(); toggleFavorite(med); }} sx={{ position: 'absolute', top: 5, right: 5, color: isFav ? '#ffc107' : '#e0e0e0' }} size="small">
                        {isFav ? <StarIcon /> : <StarBorderIcon />}
                    </IconButton>
                    <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold', lineHeight: 1.2, mb: 1, pr: 3, fontSize: '1.05rem' }}>{med.name}</Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: '#444', mb: 0.5 }}>{med.activeIngredient || 'Generico'}</Typography>
                    {med.laboratory && (<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1, color: 'text.secondary', fontSize: '0.8rem' }}><BusinessIcon sx={{ fontSize: 14 }} /> {med.laboratory}</Box>)}
                    <Divider sx={{ my: 1 }} />
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
                        {med.concentration && <Chip label={med.concentration} size="small" color="primary" variant="outlined" sx={{fontSize:'0.75rem'}} />}
                        {med.pharmaceuticalForm && <Chip label={med.pharmaceuticalForm} size="small" sx={{ bgcolor: '#f5f5f5', fontSize:'0.75rem' }} />}
                    </Box>
                    {med.contraindications && med.contraindications.length > 10 && (
                        <Box onClick={() => { setCurrentMed(med); setOpenContra(true); }} sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 1, color: '#d32f2f', mt: 1, fontSize: '0.75rem', fontWeight: 'bold' }}>
                            <WarningIcon fontSize="small" /> Ver Precauciones
                        </Box>
                    )}
                </CardContent>
                <Box sx={{ p: 1, bgcolor: '#fafafa', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'space-between' }}>
                    <Box>
                        <Tooltip title="Ver Ficha"><IconButton size="small" color="info" onClick={() => { setCurrentMed(med); setOpenDetail(true); }}><VisibilityIcon fontSize="small"/></IconButton></Tooltip>
                        {canEdit(med) && <Tooltip title="Editar"><IconButton size="small" color="primary" onClick={() => { setCurrentMed(med); setOpenForm(true); }}><EditIcon fontSize="small"/></IconButton></Tooltip>}
                    </Box>
                    <Fab size="small" color="primary" onClick={() => handleAddCart(med)} sx={{ width: 36, height: 36, minHeight:36 }}><AddShoppingCartIcon fontSize="small" /></Fab>
                </Box>
            </Card>
        );
    };

    return (
        <Box sx={{ p: 3, maxWidth: '1400px', margin: '0 auto', pb: 10 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3, alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                <Typography variant="h4" color="primary" sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 'bold' }}><PharmacyIcon fontSize="large" /> Vademécum Institucional</Typography>
                <Button variant="contained" startIcon={<AddIcon />} onClick={() => { setCurrentMed({ id: null, name: '', activeIngredient: '', laboratory: '', atcCode: '', therapeuticClass: '', concentration: '', pharmaceuticalForm: '', administrationVia: '', indications: '', posology: '', contraindications: '' }); setOpenForm(true); }}>Nuevo Medicamento</Button>
            </Box>

            <Accordion expanded={showFavorites} onChange={() => setShowFavorites(!showFavorites)} sx={{ mb: 3, border: '1px solid #ffe082', bgcolor: '#fff8e1' }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#f57f17' }}>
                        <StarIcon /> ⭐ MIS FAVORITOS ({favorites.length}) {loadingFavs && <CircularProgress size={16} sx={{ml:1}} />}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ maxHeight: '450px', overflowY: 'auto', pr: 1 }}> 
                    {favorites.length === 0 ? (
                        <Typography variant="body2" fontStyle="italic" color="text.secondary">Aún no ha añadido favoritos. Haga clic en la estrella para guardar en la nube.</Typography>
                    ) : (
                        <Grid container spacing={2}>
                            {/* FAVORITOS ORDENADOS ALFABÉTICAMENTE */}
                            {sortedFavorites.map(med => (<Grid item xs={12} sm={6} md={4} lg={3} key={med.id}>{renderMedCard(med)}</Grid>))}
                        </Grid>
                    )}
                </AccordionDetails>
            </Accordion>

            <Card elevation={2} sx={{ mb: 4, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', p: 1 }}>
                    <TextField fullWidth placeholder="Buscar por Nombre, Principio Activo, Código ATC..." value={search} onChange={e => { setSearch(e.target.value); setLoading(true); }} InputProps={{ disableUnderline: true, startAdornment: <InputAdornment position="start"><SearchIcon color="action" /></InputAdornment>, endAdornment: search ? <IconButton onClick={() => setSearch('')}><CloseIcon /></IconButton> : null, style: { fontSize: '1.1rem', padding: '8px' } }} variant="standard" />
                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                    {activeAtcFilter && (<Chip label={`${activeAtcFilter.code} - ${activeAtcFilter.label}`} onDelete={() => { setActiveAtcFilter(null); fetchMeds(debouncedSearch, null); }} color="primary" sx={{ mr: 1, maxWidth: 200 }} />)}
                    <Button startIcon={<FilterIcon />} onClick={() => { setAtcSelectorMode('filter'); setOpenAtcSelector(true); }} sx={{ whiteSpace: 'nowrap', px: 3 }}>{activeAtcFilter ? 'Cambiar Categoría' : 'Explorar Categorías'}</Button>
                </Box>
            </Card>

            {loading ? (
                <Box sx={{ textAlign: 'center', mt: 8, mb: 8 }}><CircularProgress size={60} thickness={4} /><Typography variant="h6" color="text.secondary" sx={{ mt: 2 }}>Buscando en la base de datos...</Typography></Box>
            ) : (
                medications.length === 0 ? (
                    <Box sx={{ textAlign: 'center', mt: 5, p: 5, bgcolor: '#f5f5f5', borderRadius: 4 }}><ScienceIcon sx={{ fontSize: 60, color: '#bdbdbd', mb: 2 }} /><Typography variant="h5" color="text.secondary" gutterBottom>NO SE ENCONTRARON RESULTADOS QUE COINCIDAN CON SU BÚSQUEDA</Typography><Typography variant="body1" color="text.secondary">Intente verificar la ortografía, buscar por principio activo o usar el filtro de categorías.</Typography></Box>
                ) : (
                    <Grid container spacing={2}>{medications.map(med => (<Grid item xs={12} sm={6} md={4} lg={3} key={med.id}>{renderMedCard(med)}</Grid>))}</Grid>
                )
            )}

            <AtcCategoryDialog open={openAtcSelector} onClose={() => setOpenAtcSelector(false)} onSelect={handleAtcSelect} />
            
            <Dialog open={openForm} onClose={() => setOpenForm(false)} maxWidth="md" fullWidth>
                <DialogTitle>{currentMed.id ? 'Editar Medicamento' : 'Nuevo Medicamento'}</DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}><TextField label="Nombre Comercial" fullWidth required value={currentMed.name} onChange={e => setCurrentMed({ ...currentMed, name: e.target.value })} helperText="Si es genérico, repita el nombre." /></Grid>
                        <Grid item xs={12} md={6}><TextField label="Principio Activo" fullWidth value={currentMed.activeIngredient} onChange={e => setCurrentMed({ ...currentMed, activeIngredient: e.target.value })} /></Grid>
                        <Grid item xs={12} md={6}><TextField label="Laboratorio" fullWidth value={currentMed.laboratory} onChange={e => setCurrentMed({ ...currentMed, laboratory: e.target.value })} /></Grid>
                        <Grid item xs={12} md={6} sx={{ display:'flex', alignItems:'flex-start', gap:1 }}>
                            <TextField label="Código ATC" fullWidth value={currentMed.atcCode} onChange={e => setCurrentMed({ ...currentMed, atcCode: e.target.value })} />
                            <Tooltip title="Seleccionar de Lista"><IconButton onClick={() => { setAtcSelectorMode('form'); setOpenAtcSelector(true); }} sx={{ mt: 1, bgcolor: '#e3f2fd' }}><FilterIcon color="primary" /></IconButton></Tooltip>
                        </Grid>
                        <Grid item xs={12} md={6}><TextField label="Grupo Terapéutico" fullWidth value={currentMed.therapeuticClass} onChange={e => setCurrentMed({ ...currentMed, therapeuticClass: e.target.value })} InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start"><CategoryIcon fontSize="small" /></InputAdornment> }} /></Grid>
                        <Grid item xs={6} md={3}><TextField label="Concentración" fullWidth value={currentMed.concentration} onChange={e => setCurrentMed({ ...currentMed, concentration: e.target.value })} /></Grid>
                        <Grid item xs={6} md={3}><TextField label="Forma" fullWidth value={currentMed.pharmaceuticalForm} onChange={e => setCurrentMed({ ...currentMed, pharmaceuticalForm: e.target.value })} /></Grid>
                        <Grid item xs={12}><Divider sx={{ my: 1 }}>TEXTOS CIENTÍFICOS</Divider></Grid>
                        <Grid item xs={12}><MacroTextField label="Indicaciones" type="indications" value={currentMed.indications} onChange={e => setCurrentMed({ ...currentMed, indications: e.target.value })} user={user} /></Grid>
                        <Grid item xs={12}><MacroTextField label="Posología" type="posology" value={currentMed.posology} onChange={e => setCurrentMed({ ...currentMed, posology: e.target.value })} user={user} /></Grid>
                        <Grid item xs={12}><MacroTextField label="Contraindicaciones" type="contraindications" value={currentMed.contraindications} onChange={e => setCurrentMed({ ...currentMed, contraindications: e.target.value })} user={user} /></Grid>
                    </Grid>
                </DialogContent>
                <DialogActions><Button onClick={() => setOpenForm(false)}>Cancelar</Button><Button variant="contained" onClick={handleSave}>Guardar</Button></DialogActions>
            </Dialog>

            <Dialog open={openDetail} onClose={() => setOpenDetail(false)} maxWidth="md" fullWidth>
                <DialogTitle sx={{ bgcolor: '#1976d2', color: 'white', display: 'flex', justifyContent: 'space-between' }}>{currentMed.name}<IconButton onClick={() => setOpenDetail(false)} sx={{ color: 'white' }}><CloseIcon /></IconButton></DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}><Typography variant="subtitle2">Principio Activo</Typography><Typography variant="body1" fontWeight="bold">{currentMed.activeIngredient}</Typography></Grid>
                        <Grid item xs={12} sm={6}><Typography variant="subtitle2">Grupo</Typography><Typography variant="body1">{currentMed.therapeuticClass} ({currentMed.atcCode})</Typography></Grid>
                        <Grid item xs={12} sx={{ mt: 2 }}><Divider /></Grid>
                        <Grid item xs={12}><Typography variant="h6" color="primary">Posología</Typography><Typography variant="body2" sx={{ whiteSpace: 'pre-line', bgcolor: '#f5f5f5', p: 2 }}>{currentMed.posology || 'N/A'}</Typography></Grid>
                        <Grid item xs={12}><Typography variant="h6" color="primary">Indicaciones</Typography><Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>{currentMed.indications || 'N/A'}</Typography></Grid>
                        {currentMed.contraindications && (<Grid item xs={12}><Typography variant="h6" color="error">Contraindicaciones</Typography><Typography variant="body2" sx={{ whiteSpace: 'pre-line', color: '#d32f2f', border: '1px solid #ffcdd2', p: 2 }}>{currentMed.contraindications}</Typography></Grid>)}
                    </Grid>
                </DialogContent>
                <DialogActions><Button onClick={() => handleAddCart(currentMed)} startIcon={<AddShoppingCartIcon />} variant="contained">Usar en Receta</Button></DialogActions>
            </Dialog>

            <Dialog open={openContra} onClose={() => setOpenContra(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ color: '#d32f2f', display: 'flex', alignItems: 'center', gap: 1 }}><WarningIcon /> ADVERTENCIA</DialogTitle>
                <DialogContent dividers><Typography variant="body1" fontWeight="bold" gutterBottom>{currentMed.name}</Typography><Box sx={{ p: 2, bgcolor: '#ffebee', borderRadius: 2 }}><Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>{currentMed.contraindications}</Typography></Box></DialogContent>
                <DialogActions><Button onClick={() => setOpenContra(false)} color="error">Entendido</Button></DialogActions>
            </Dialog>

            {/* --- DIÁLOGO CARRITO (CON CORRECCIÓN DE ID) --- */}
            <Dialog open={openCart} onClose={() => setOpenCart(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
                        <ReceiptIcon color="secondary"/> Medicamentos Seleccionados ({clipboardItems?.length || 0})
                    </Box>
                    <IconButton onClick={() => setOpenCart(false)}><CloseIcon /></IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {(!clipboardItems || clipboardItems.length === 0) ? (
                        <Box sx={{ textAlign:'center', py:4, color:'text.secondary' }}>
                            <ShoppingCartIcon sx={{ fontSize:60, opacity:0.2, mb:2 }} />
                            <Typography>No hay medicamentos seleccionados aún.</Typography>
                        </Box>
                    ) : (
                        <List>
                            {clipboardItems.map((item) => (
                                // USAMOS EL ID ÚNICO COMO KEY PARA QUE REACT NO SE PIERDA
                                <ListItem key={item.cartId} divider>
                                    <ListItemText 
                                        primary={item.commercialName} 
                                        secondary={`${item.activeIngredient} - ${item.concentration}`} 
                                    />
                                    <ListItemSecondaryAction>
                                        <IconButton edge="end" color="error" onClick={() => handleRemoveFromCart(item.cartId)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            ))}
                        </List>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { if(clearClipboard) clearClipboard(); }} color="error" startIcon={<DeleteSweepIcon />} disabled={!clipboardItems?.length}>
                        Vaciar Todo
                    </Button>
                    <Button onClick={() => setOpenCart(false)} variant="contained">
                        Seguir Agregando
                    </Button>
                </DialogActions>
            </Dialog>

            <Box sx={{ position: 'fixed', bottom: 30, right: 30, zIndex: 999 }}>
                <Fab color="secondary" variant="extended" onClick={() => setOpenCart(true)}>
                    <Badge badgeContent={clipboardItems?.length || 0} color="error">
                        <ShoppingCartIcon sx={{ mr: 1 }} />
                    </Badge>
                    Mi Recipe
                </Fab>
            </Box>

            <Snackbar open={!!notification} autoHideDuration={3000} onClose={() => setNotification('')} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}><Alert severity={notification.includes('❌') ? 'error' : 'success'} variant="filled">{notification}</Alert></Snackbar>
        </Box>
    );
};

export default VademecumPage;